"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8847],{

/***/ 88847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ZigZagType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91932);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62290);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53429);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83974);
/* harmony import */ var _ViewPort__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39806);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31969);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75547);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);









function ZigZagType(props) {
    var showFullContent = props.hasOwnProperty("showFullContent") ? props.showFullContent : false;
    var myRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    myRefs.current = [];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), nextElementHeight = ref[0], updateNextElementHeight = ref[1];
    var addToRefs = function(el) {
        if (el && !myRefs.current.includes(el.children[0])) {
            myRefs.current.push(el.children[0]);
        }
    };
    var setHeight = function(target, images) {
        var element = target.parentElement.parentElement;
        var height = 500;
        // console.log(element.children[0].children[1]);
        setTimeout(function() {
            if (element.style.height === "auto" && images) {
                if (element.nextSibling.children[0].clientHeight > 500) {
                    height = element.nextSibling.children[0].clientHeight;
                }
                element.style.height = height + "px";
            // element.children[0].children[1].classList.remove('invisible');
            }
        }, 500);
    };
    var builder = props.builder;
    var content = props.content;
    var articles = props.articles;
    var container_class = "container-fluid";
    if (props.type == "blog" && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(builder.builder_news_view_width)) {
        container_class = builder.builder_news_view_width;
    } else if (props.type == "category" && _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(content.category_view_width)) {
        container_class = content.category_view_width;
    }
    var isMobile = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isMobile"];
    });
    var skeletonArticles = [];
    for(var i = 0; i < 6; i++){
        var row_class = !(i % 2 == 0) ? "row flex-sm-row-reverse w-100 m-0" : "row w-100 m-0";
        var text_class = !(i % 2 == 0) ? "col-12 col-sm-12 col-md-6 text-start text-md-end" : "col-12 col-sm-12 col-md-6";
        skeletonArticles.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: row_class,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-12 col-sm-6 p-0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        height: 400,
                        className: "col-12"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: text_class + " py-5",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            height: 18,
                            className: "col-12 col-sm-6 col-md-4"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            height: 25,
                            className: "col-12 col-sm-8 col-md-6 mb-3"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            height: 18,
                            className: "col-12 col-sm-8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            height: 18,
                            className: "col-12 col-sm-8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            height: 18,
                            className: "col-12 col-sm-8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            height: 18,
                            className: "col-12 col-sm-8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            height: 18,
                            className: "col-12 col-sm-8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            height: 18,
                            className: "col-12 col-sm-8"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            height: 18,
                            className: "col-12 col-sm-8"
                        })
                    ]
                })
            ]
        }, i.toString()));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: container_class + " p-t-0 p-b-0  p-l-0 p-r-0",
        children: props.loadingArticles ? skeletonArticles : articles.map(function(article, key) {
            var flag = article.has_description == "1" || article.has_body;
            var row_class = "row row-flex w-100 m-0";
            var text_class = "col-12 col-sm-12 col-md-6";
            if (!(key % 2 == 0)) {
                row_class = "row flex-sm-row-reverse w-100 m-0";
                text_class = "col-12 col-sm-12 col-md-6 text-start text-md-end";
            }
            row_class += " zig-photo";
            var subtitle = props.articlesContentType == "article" ? article.subtitle : props.articlesContentType == "blog" ? article.title : article.description;
            var description = props.articlesContentType == "article" || props.articlesContentType == "blog" ? article.description : article.body;
            var created = props.articlesContentType == "blog" ? moment__WEBPACK_IMPORTED_MODULE_2___default()(new Date(article.created * 1000)).format("dddd Do MMMM") : null;
            if (props.hasOwnProperty("articlesLimit") && (key < props.articlesLimit || props.articlesLimit === null) || !props.hasOwnProperty("articlesLimit")) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ViewPort__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    parentClassName: row_class,
                    skeletonItem: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 col-sm-6 p-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    height: 400,
                                    className: "col-12"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: text_class + " py-5",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        height: 18,
                                        className: "col-12 col-sm-6 col-md-4"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        height: 25,
                                        className: "col-12 col-sm-8 col-md-6 mb-3"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        height: 18,
                                        className: "col-12 col-sm-8"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        height: 18,
                                        className: "col-12 col-sm-8"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        height: 18,
                                        className: "col-12 col-sm-8"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        height: 18,
                                        className: "col-12 col-sm-8"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        height: 18,
                                        className: "col-12 col-sm-8"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        height: 18,
                                        className: "col-12 col-sm-8"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        height: 18,
                                        className: "col-12 col-sm-8"
                                    })
                                ]
                            })
                        ]
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: row_class,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 col-sm-12 col-md-6 p-0 zig-photo-container",
                                style: {
                                    height: isMobile ? "400px" : ""
                                },
                                onLoad: function(e) {
                                    setHeight(e.target, _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image));
                                    if (nextElementHeight.length === 0) {
                                        updateNextElementHeight(myRefs.current);
                                    }
                                },
                                children: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidString */ .Z.isValidString(article.image) && //showImageState == 'image-'+article.id &&
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    layout: "fixed",
                                    sizes: "75vw",
                                    quality: "75",
                                    height: 1600,
                                    width: 1000,
                                    src: article.image,
                                    alt: "Post Img",
                                    placeholder: "blur",
                                    blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: addToRefs,
                                className: text_class + " align-items-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: " pb-5 pt-5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "py-5 px-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                className: props.textColor + " block-title mb-0",
                                                children: article.title
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: props.textColor + " mt-0 fw-normal hidden-xs hidden-sm hidden-md",
                                                children: subtitle
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: props.textColor + " mt-0 fw-normal visible-xs visible-sm visible-md",
                                                children: subtitle
                                            }),
                                            created != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: created
                                            }),
                                            showFullContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: description != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: props.textColor,
                                                        dangerouslySetInnerHTML: {
                                                            __html: description
                                                        }
                                                    })
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    description != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: props.textColor,
                                                            dangerouslySetInnerHTML: {
                                                                __html: description.slice(0, 250) + (description.length > 0 ? "..." : "")
                                                            }
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                                                    (article.has_description == "1" || article.has_body) && article.loggiaUrl != null && article.loggiaUrl.length > 0 && article.loggiaUrl.startsWith("/") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                            href: props.updateHref(article),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                onClick: function() {
                                                                    return props.clickHandler(article);
                                                                },
                                                                className: "btn-link text-link fs-16",
                                                                children: "Read more"
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }, key.toString())
                }, article.id.toString());
            }
        })
    });
}


/***/ })

}]);